var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFe4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1435_12216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.35 7.57007V9.44007H15.02C13.92 9.44007 13.04 9.71007 12.37 10.2401C11.71 10.7701 11.37 11.4801 11.37 12.3701V13.3601C11.37 14.1201 11.63 14.7501 12.14 15.2501C12.65 15.7501 13.37 16.0801 14.3 16.2401L17.6 16.7901C18.16 16.8801 18.6 17.0701 18.93 17.3601C19.25 17.6501 19.42 18.0101 19.42 18.4201V19.5901C19.42 20.1201 19.2 20.5401 18.76 20.8601C18.32 21.1801 17.74 21.3501 17.02 21.3501H14.99C14.26 21.3501 13.67 21.1101 13.22 20.6401C12.77 20.1701 12.55 19.5601 12.55 18.8001H11.23C11.23 19.5401 11.39 20.2001 11.7 20.7701C12.01 21.3401 12.45 21.7801 13.01 22.0901C13.57 22.4001 14.22 22.5601 14.95 22.5601H15.35V24.4301H16.67V22.5601H17.05C18.16 22.5601 19.06 22.2901 19.74 21.7401C20.42 21.2001 20.77 20.4801 20.77 19.5901V18.4201C20.77 17.6801 20.51 17.0601 19.98 16.5801C19.45 16.1001 18.72 15.7701 17.76 15.6001L14.48 15.0301C13.93 14.9301 13.5 14.7401 13.19 14.4401C12.88 14.1501 12.72 13.7901 12.72 13.3601V12.3701C12.72 11.8501 12.93 11.4301 13.34 11.1201C13.75 10.8101 14.31 10.6501 15.01 10.6501H17.08C17.73 10.6501 18.25 10.8501 18.64 11.2501C19.03 11.6501 19.23 12.1901 19.23 12.8601H20.55C20.55 11.8301 20.23 11.0101 19.6 10.3801C18.97 9.75007 18.13 9.44007 17.09 9.44007H16.67V7.57007H15.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.9198 6.90005C31.7598 6.62005 31.3898 6.52005 31.1098 6.68005L28.3298 8.27005L16.2998 1.32005C16.1198 1.21005 15.8898 1.21005 15.7098 1.32005L3.42978 8.40005C3.24978 8.51005 3.12978 8.70005 3.12978 8.91005V22.74L0.299778 24.3601C0.0197777 24.5201 -0.0802223 24.89 0.0797777 25.17C0.189778 25.3601 0.389778 25.47 0.599778 25.47C0.699778 25.47 0.799778 25.44 0.889778 25.39L3.72978 23.7701L15.7098 30.68C15.7998 30.73 15.8998 30.76 16.0098 30.76C16.1098 30.76 16.2098 30.73 16.3098 30.68L28.5798 23.59C28.7598 23.48 28.8798 23.29 28.8798 23.08V9.33005L31.7098 7.71005C31.9898 7.55005 32.0798 7.18005 31.9198 6.90005ZM27.6798 22.74L15.9998 29.48L4.31978 22.74V9.26005L15.9998 2.52005L27.6798 9.26005V22.74Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1435_12216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFe4);
export default __webpack_public_path__ + "static/media/fe-4.852247f0ab7e10a8db176cbc6775333a.svg";
export { ForwardRef as ReactComponent };